
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-xgujsu",
"minContentWidth": "--awsui-min-content-width-xgujsu",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-xgujsu",
"contentGapLeft": "--awsui-content-gap-left-xgujsu",
"contentGapRight": "--awsui-content-gap-right-xgujsu",
"contentHeight": "--awsui-content-height-xgujsu",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-xgujsu",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-xgujsu",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-xgujsu",
"defaultMaxContentWidth": "--awsui-default-max-content-width-xgujsu",
"defaultMinContentWidth": "--awsui-default-min-content-width-xgujsu",
"drawerSize": "--awsui-drawer-size-xgujsu",
"footerHeight": "--awsui-footer-height-xgujsu",
"headerGap": "--awsui-header-gap-xgujsu",
"headerHeight": "--awsui-header-height-xgujsu",
"layoutWidth": "--awsui-layout-width-xgujsu",
"mainGap": "--awsui-main-gap-xgujsu",
"mainOffsetLeft": "--awsui-main-offset-left-xgujsu",
"mainTemplateRows": "--awsui-main-template-rows-xgujsu",
"mobileBarHeight": "--awsui-mobile-bar-height-xgujsu",
"notificationsHeight": "--awsui-notifications-height-xgujsu",
"offsetTop": "--awsui-offset-top-xgujsu",
"overlapHeight": "--awsui-overlap-height-xgujsu",
"navigationWidth": "--awsui-navigation-width-xgujsu",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-xgujsu",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-xgujsu",
"splitPanelHeight": "--awsui-split-panel-height-xgujsu",
"splitPanelMinWidth": "--awsui-split-panel-min-width-xgujsu",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-xgujsu",
"toolsMaxWidth": "--awsui-tools-max-width-xgujsu",
"toolsWidth": "--awsui-tools-width-xgujsu",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-xgujsu",
"contentScrollMargin": "--awsui-content-scroll-margin-xgujsu",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-xgujsu",
"flashbarStackIndex": "--awsui-flashbar-stack-index-xgujsu",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-xgujsu",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-xgujsu",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-xgujsu",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-xgujsu",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-xgujsu",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-xgujsu",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-xgujsu",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-xgujsu",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-xgujsu",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-xgujsu",
"sliderLabelCount": "--awsui-slider-label-count-xgujsu",
"sliderTickCount": "--awsui-slider-tick-count-xgujsu",
"sliderReferenceColumn": "--awsui-slider-reference-column-xgujsu",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-xgujsu",
"sliderMaxStart": "--awsui-slider-max-start-xgujsu",
"sliderMinEnd": "--awsui-slider-min-end-xgujsu",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-xgujsu",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-xgujsu",
"togglesLeftWidth": "--awsui-toggles-left-width-xgujsu",
"togglesRightWidth": "--awsui-toggles-right-width-xgujsu",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-xgujsu",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-xgujsu",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-xgujsu",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-xgujsu",
      };
      export default customCSSPropertiesMap;
    